import React from "react";
import BackToHome from "../components/BackToHome";

export default function Privacy() {
  return (
    <main className="legal container pad">
      <BackToHome />
      <h1>プライバシーポリシー</h1>
      <p>個人事業「ベースボール」（代表：大倉恭弘、以下「当オフィス」）は、本サービス「MentalGPT」における個人情報の取扱いについて以下の通り定めます。</p>

      <h2>1. 取得する情報</h2>
      <ul>
        <li>アカウント情報（メールアドレス等）</li>
        <li>相談内容（ユーザー入力テキスト）</li>
        <li>技術情報（Cookie、IP、端末情報、利用ログ 等）</li>
      </ul>

      <h2>2. 利用目的</h2>
      <ul>
        <li>本サービスの提供・改善・不正利用防止</li>
        <li>ユーザーサポート、重要なお知らせの通知</li>
        <li>法令遵守のため</li>
      </ul>

      <h2>3. 第三者提供</h2>
      <p>法令に基づく場合を除き、本人の同意なく第三者に個人情報を提供しません。</p>

      <h2>4. 外部サービスの利用</h2>
      <p>
        本サービスは Firebase（認証・データ保存）、Stripe（決済）、OpenAI API（AI応答生成）を利用します。
        入力されたテキストはAI応答生成のため OpenAI に送信される場合があります。
        クレジットカード情報は当オフィスでは保持しません。
      </p>

      <h2>5. セキュリティ</h2>
      <p>適切な安全管理措置を講じ、個人情報の漏えい等の防止に努めます。</p>

      <h2>6. 開示・訂正・削除</h2>
      <p>ユーザーは、法令に基づき、ご自身の情報の開示等を請求できます。</p>

      <h2>7. お問い合わせ</h2>
      <p>本ポリシーに関するお問い合わせは <a href="mailto:info@okulab.com">info@okulab.com</a> まで。</p>

      <h2>8. 入力内容の注意</h2>
      <p>個人情報や機微な情報の入力はお控えください。入力内容はAI応答生成のために外部サービスで処理される場合があります。</p>

      <p className="date">制定：2025年8月31日 / 最終更新：2025年8月31日</p>
    </main>
  );
}